export default __webpack_public_path__ + "static/media/equipments-logo.0d906a57.png";